<template>
	<b-form-invalid-feedback :state="isValid">
		<ul>
			<li
				v-for="(error, index) in getInvalidMessage"
				:key="index"
			>
				{{ error }}
			</li>
		</ul>
	</b-form-invalid-feedback>
</template>

<script>
export default {
	name: "Validatorian",

	props: ["field", "response"],

	data: function () {
		return {
			validation_errors_unpacked: [],
		};
	},

	computed: {
		isValid() {
			let obj = this.validation_errors_unpacked.find(
				(o) => o.prop === this.field
			);
			if (obj) {
				return false;
			}
			return true;
		},
		getInvalidMessage() {
			let obj = this.validation_errors_unpacked.find(
				(o) => o.prop === this.field
			);
			if (obj) {
				return obj.errors;
			}
			return [];
		},
	},

	methods: {
		unpackValidationObject(r) {
			let errors = [];
			for (var p in r.ModelState) {
				if (r.ModelState.hasOwnProperty(p)) {
					let n = p.lastIndexOf(".");
					errors.push({
						prop: p.substring(n + 1),
						errors: r.ModelState[p],
					});
				}
			}
			this.validation_errors_unpacked = errors;
		},
	},

	watch: {
		response(r) {
			this.unpackValidationObject(r);
		},
	}
};
</script>


// WEBPACK FOOTER //
// src/components/partials/validatorian.vue